import Calendar from "./modules/arena-schedule/Calendar";

function App() {
	return (
		<div className={"container-fluid"}>
			<Calendar />
		</div>
	);
}

export default App;
